var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 130,
    viewBox: "0 0 122 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7648 120.119C29.6958 120.119 3.50676 94.535 2.49176 62.708C1.61976 62.506 0.96875 61.729 0.96875 60.797C0.96875 27.273 28.2418 0 61.7648 0C62.6988 0 63.4748 0.650996 63.6758 1.522C95.5048 2.537 121.089 28.727 121.089 60.797C121.089 93.507 94.4768 120.119 61.7648 120.119ZM63.6468 2.504C63.4108 3.325 62.6628 3.93 61.7648 3.93C30.4108 3.93 4.89975 29.441 4.89975 60.797C4.89975 61.694 4.29575 62.443 3.47375 62.678C4.47275 93.978 30.2278 119.136 61.7648 119.136C93.9338 119.136 120.107 92.966 120.107 60.797C120.107 29.259 94.9458 3.503 63.6468 2.504ZM61.7648 74.779C54.0548 74.779 47.7827 68.507 47.7827 60.797C47.7827 53.087 54.0548 46.813 61.7648 46.813C69.4768 46.813 75.7498 53.087 75.7498 60.797C75.7498 68.507 69.4768 74.779 61.7648 74.779ZM61.7648 48.778C55.1398 48.778 49.7477 54.17 49.7477 60.797C49.7477 67.423 55.1398 72.814 61.7648 72.814C68.3928 72.814 73.7838 67.423 73.7838 60.797C73.7838 54.17 68.3928 48.778 61.7648 48.778Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8584 109.639C83.7878 109.639 104.808 87.2555 104.808 59.6445H57.8584V109.639Z",
    fill: "#2E18EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 41.8584,
    y: 47.6445,
    width: 78.95,
    height: 81.9946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0999163 0 0 0 0 0.0302041 0 0 0 0 0.721517 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar2);
export default __webpack_public_path__ + "static/media/radar2.e4c74f65772555a1ed48f15703670130.svg";
export { ForwardRef as ReactComponent };